import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";
import { SkeletonWrapper } from "shared-ui";

const SingleDataWithLabels = ({
  data,
  label,
  loading,
  containerStyle,
  showValue = true,
}: {
  data: any;
  label: string;
  loading?: boolean;
  containerStyle?: any;
  showValue?: boolean;
}) => {
  const numberFormatter = new Intl.NumberFormat("en-US");
  return (
    <Grid container sx={[{ width: "100%" }, containerStyle]}>
      <Grid size={7} container alignItems="center">
        <SkeletonWrapper loading={loading}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            {label}
          </Typography>
        </SkeletonWrapper>
      </Grid>
      {showValue && (
        <Grid size={5} container justifyContent="flex-end">
          <SkeletonWrapper loading={loading}>
            <Typography sx={{ fontSize: "20px", textAlign: "right" }}>
              {typeof data === "number" ? numberFormatter.format(data) : data}
            </Typography>
          </SkeletonWrapper>
        </Grid>
      )}
    </Grid>
  );
};
export default SingleDataWithLabels;
